import { useMutation } from "react-query";
import completeBmca from "../services/completeBmca";

function useCompleteBmca() {
  return useMutation(["complete-bmca"], completeBmca);
}

export default useCompleteBmca;
